export default __webpack_public_path__ + "images/fab653ac4a7ade5c91a1cd73c449fc19-dont_10.png";